import { Component, OnInit } from '@angular/core';
import { VoucherService } from 'app/resources/services/voucher.service';
import { Cartao } from 'app/resources/classes/cartao';
import { VoucherResgatarComponent } from '../voucher-resgatar.component';

@Component({
  selector: 'app-voucher-lista-adicionais',
  templateUrl: './voucher-lista-adicionais.component.html'
})
export class VoucherListaAdicionaisComponent implements OnInit {

  constructor(public voucherService: VoucherService, public voucherResgatarComponent: VoucherResgatarComponent) { }

  ngOnInit() {
  }

  public removerVoucher(voucher: Cartao): void {
    const vouchersAdicionais: Array<Cartao> = [];
    bootbox.confirm('Deseja remover o Voucher?', (result) => {
      if (result) {
        for (const item of this.voucherService.vouchersAdicionais) {
          if (item.getNumero().trim() !== voucher.getNumero().trim()) {
            vouchersAdicionais.push(item);
          }
        }
        this.voucherService.vouchersAdicionais = vouchersAdicionais;
        this.voucherResgatarComponent.vouchersInvalidos = [];
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/voucher/voucher-resgatar/voucher-lista-adicionais/voucher-lista-adicionais.component.ts